import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ClockCircleOutlined,
  ControlOutlined,
  EyeInvisibleOutlined,
  FireOutlined,
  GiftOutlined,
  ThunderboltOutlined,
  UserSwitchOutlined
} from '@ant-design/icons';

import './features.scss';

export const Features = () => {
  const { t } = useTranslation('features');

  const list = [
    {
      title: t('card_1_title'),
      description: t('card_1_description'),
      icon: UserSwitchOutlined
    },
    {
      title: t('card_2_title'),
      description: t('card_2_description'),
      icon: ClockCircleOutlined
    },
    {
      title: t('card_3_title'),
      description: t('card_3_description'),
      icon: FireOutlined
    },
    {
      title: t('card_4_title'),
      description: t('card_4_description'),
      icon: ThunderboltOutlined
    },
    {
      title: t('card_5_title'),
      description: t('card_5_description'),
      icon: EyeInvisibleOutlined
    },
    {
      title: t('card_6_title'),
      description: t('card_6_description'),
      icon: GiftOutlined
    },
    {
      title: t('card_7_title'),
      description: t('card_7_description'),
      icon: ControlOutlined
    }
  ];

  return (
    <section id="features" className="landing__features">
      <h2 className="landing__features-title">{t('title')}</h2>
      <p className="landing__features-intro">{t('description')}</p>

      <div className="landing__features-grid">
        {list.map((item) => {
          const Icon = item.icon;

          return (
            <div className="landing__feature-card" key={item.title}>
              <div className="landing__feature-icon landing__feature-icon--accent">
                <Icon />
              </div>
              <h3 className="landing__feature-title">{item.title}</h3>
              <div
                className="landing__feature-text"
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
};
